import { useSelector } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react'
import { OnAuth0Logout } from 'functions/auth0Utils'
import kinesisLogo from 'media/kinesis_logo.png'

import ContentFrame from 'components/Frame/ContentFrame'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function InvalidAuth0ConnectionView() {

    const { logout } = useAuth0()

    const email = useSelector(state => state.user.email)
    const auth0UserId = useSelector(state => state.user.auth0UserId)

    return (
        <div className='fixed h-full w-full flex bg-gray-100'>
            <div className='max-w-6xl mx-auto p-4 space-y-4'>
                <img 
                    src={kinesisLogo} 
                    alt="Kinesis Logo" 
                    className="w-60 mx-auto mb-10" 
                />

                <h1 className="text-2xl font-semibold text-center text-gray-900 tracking-tight pb-4 flex-grow">
                    Incorrect Login Method
                </h1>

                <div className="text-center text-gray-600 space-y-4">
                    <ContentFrame>
                        <div className="p-4 space-y-4">
                            <p>A coach account for <strong className="text-gray-800">{email}</strong> was found, but the login method was incorrect.</p>
                            <p>Try logging out and logging back in with the proper method.</p>
                        </div>
                    </ContentFrame>

                    <ContentFrame>
                        <div className="w-full p-4 flex items-center">
                            <p className='text-left flex-grow'>Proper method:</p>

                            {auth0UserId?.startsWith("google") && <p className='text-right font-semibold'>Google</p>}

                            {auth0UserId?.startsWith("auth0") && <p className='text-right font-semibold'>Email/Password</p>}

                            {auth0UserId?.startsWith("apple") && <p className='text-right font-semibold'>Apple</p>}
                        </div>
                    </ContentFrame>
                </div>

                <div className='pt-4'>
                    <BrandColorButton
                        size="large"
                        text="Logout"
                        action={() => OnAuth0Logout(logout)}
                        className='shadow-md'
                    />
                </div>
            </div>

            <div className='absolute w-full bottom-10'>
                <p className='text-center text-gray-600'>
                    Need help? Contact us at <a href="mailto:support@kinesisintegrated.com" className="text-blue-500 underline">support@kinesisintegrated.com</a>
                </p>
            </div>
        </div>
    )
}
